import { useMemo } from "react";
import TabsComponent from "/components/core/tabs/tabs-component";
import TabComponent from "/components/core/tabs/tab/tab-component";
import { ALIGN_TYPES } from "constants/align-types";
import { getTabsInfo } from "./tabs";
import { withGenericConfig } from "/contexts/generic-config-context";

import { componentStyles } from "./template-page-tabs.scss";

const TemplatePageTabs = (props) => {
  const { templateData, translate, tabsMetadata } = props;

  const renderTabs = useMemo(() => {
    return getTabsInfo(tabsMetadata).map((tabInfo) => {
      const { component: ContentComponent, ...moreTabContentProps } = tabInfo;
      const { titleKey } = moreTabContentProps;
      return (
        <TabComponent
          label={translate(titleKey)}
          key={titleKey}
          labelTranslationKey={titleKey}
          useSmallLabels={true}
          color="dodger-blue"
        >
          <ContentComponent templateData={templateData} {...moreTabContentProps} />
        </TabComponent>
      );
    });
  }, [tabsMetadata, templateData, translate]);

  return (
    <div className="template-page-tabs">
      <TabsComponent
        autoTransition={false}
        role="tabpanel"
        className="template-page-tabs-component"
        tabsAlign={ALIGN_TYPES.LEFT}
      >
        {renderTabs}
      </TabsComponent>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(TemplatePageTabs);
